import qs from 'qs';
import moment from 'moment-mini';

import { ISearchOpportunitiesSort, SearchOpportunitiesSort } from '@joc/api-gateway';

export const parseQuery = (search: string): any => qs.parse(search, { ignoreQueryPrefix: true }) as any;

export const parseSearchText = (query: any): string | undefined =>
	query?.fullTextSearch?.value ? String(query.fullTextSearch.value) : undefined;

export const parseSortFromQuery = (query: any): SearchOpportunitiesSort | undefined =>
	query?.sort ? SearchOpportunitiesSort.fromJS(query.sort) : undefined;

export const parseOrganisationIds = (query: any): Array<number> | undefined => {
	const raw = query?.organisationIds ?? query?.organisationId ?? query?.organizationIds ?? query?.organizationId;

	if (!raw || raw === 'Private') return undefined;
	if (Array.isArray(raw)) {
		return raw.map((v: any) => Number(v)).filter((v: number) => !Number.isNaN(v));
	}

	const asNum = Number(raw);
	return Number.isNaN(asNum) ? undefined : [asNum];
};

export const parseStartDayFromQuery = (query: any): { fromDate?: Date; toDate?: Date } | undefined => {
	const startDayRaw = query?.startDay;
	if (!startDayRaw || typeof startDayRaw !== 'object') return undefined;

	const fromRaw = startDayRaw.fromDate ?? startDayRaw.startDate;
	const toRaw = startDayRaw.toDate ?? startDayRaw.endDate;
	if (!fromRaw && !toRaw) return undefined;

	return {
		fromDate: fromRaw ? new Date(fromRaw) : undefined,
		toDate: toRaw ? new Date(toRaw) : undefined,
	};
};

export const clearFilterParams = (query: any): any => {
	const next = { ...query };
	delete next.startDay;
	delete next.organisationIds;
	delete next.organisationId;
	delete next.organizationIds;
	delete next.organizationId;
	return next;
};

export const applyStartDayToQuery = (query: any, values: { fromDate: Date | null; toDate: Date | null }): any => {
	const next = { ...query };
	if (values.fromDate || values.toDate) {
		next.startDay = {
			fromDate: values.fromDate ? moment(values.fromDate).startOf('day').toISOString() : undefined,
			toDate: values.toDate ? moment(values.toDate).endOf('day').toISOString() : undefined,
		};
	} else {
		delete next.startDay;
	}
	return next;
};

export const applyOrganisationToQuery = (
	query: any,
	organisationId: string | null,
	enableOrganizationFilter: boolean
): any => {
	const next = { ...query };
	if (enableOrganizationFilter) {
		if (organisationId) next.organisationIds = [Number(organisationId)];
		else delete next.organisationIds;
		return next;
	}
	delete next.organisationIds;
	delete next.organisationId;
	delete next.organizationIds;
	delete next.organizationId;
	return next;
};

export const stringifyQuery = (query: any): string => qs.stringify(query);

export const updateQueryParam = (
	search: string,
	key: string,
	value: Partial<ISearchOpportunitiesSort> | { value: string; fields: Array<any> }
): string => {
	const query = parseQuery(search);
	query[key] = value;
	return stringifyQuery(query);
};
